/* eslint-disable react/jsx-props-no-spreading */
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Link as MuiLink, Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';
import { loc } from '../../../../constants/strings/local';
import './footer.scss';
import Faq from '../../../../static/resources/wallet-faq.pdf';
import builderFaq from '../../../../static/resources/wallet-builder-faq.pdf';
import { routePath } from '../../../../constants/strings/RoutePath';

const Footer = (props) => {
    const footerClassName = get(props, 'footerClassName', 'privacy-footer');
    const { t: trans } = useTranslation();
    const commonAttributesFunction = (otherClass) => ({
        underline: 'none',
        rel: 'noopener noreferrer',
        target: '_blank',
        color: '#939191',
        sx: { ':hover': { color: 'primary.main' } },
        className: `body2 ${otherClass}`,
    });
    const commonAttributes = commonAttributesFunction('');
    const walletUser = useSelector(
        (state) => state?.auth?.data?.WalletUserSettings,
    );
    const location = useLocation();
    const spanStyle = {
        color:
            location.pathname === routePath.releaseNote ? '#939191' : 'inherit',
    };
    return (
        <Stack
            p="10px"
            direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
            justifyContent="center"
            className={footerClassName}
        >
            <Box className="footer-text-align">
                <Box>
                    <span className="footer-text m-0" style={spanStyle}>
                        {trans(loc.footer.copyrightStart)}&nbsp;
                    </span>
                </Box>
                <Box>
                    <MuiLink
                        href={loc.footer.hyphenSolutionLink}
                        {...commonAttributesFunction('footer-company-name')}
                    >
                        {trans(loc.footer.copyrightMiddle)}&nbsp;
                    </MuiLink>
                </Box>

                <span className="footer-text m-0" style={spanStyle}>
                    {trans(loc.footer.copyrightEnd)}&nbsp;
                </span>
            </Box>
            <Stack className="justify-center footer-se" direction="row">
                <MuiLink href={loc.footer.privacyLink} {...commonAttributes}>
                    {trans(loc.footer.privacy)}
                </MuiLink>
                <span
                    className="body2 footer-company-name font-change-footer"
                    style={spanStyle}
                >
                    {' '}
                    &nbsp;|&nbsp;
                </span>
                <MuiLink
                    component={RouterLink}
                    to={loc.footer.termsLink}
                    state={{ from: walletUser ? 'dashboard' : 'home' }}
                    underline="none"
                    sx={{
                        color: '#939191',
                        ':hover': { color: 'primary.main' },
                    }}
                    rel="noopener noreferrer"
                >
                    {trans(loc.footer.terms)}
                </MuiLink>
                <span
                    className="body2 footer-company-name font-change-footer"
                    style={spanStyle}
                >
                    {' '}
                    &nbsp;|&nbsp;
                </span>
                <MuiLink
                    href={
                        walletUser?.usergroupType === 'Builder'
                            ? builderFaq
                            : Faq
                    }
                    {...commonAttributes}
                >
                    FAQ
                </MuiLink>
                {walletUser?.usergroupType &&
                location?.pathname !== routePath.releaseNote ? (
                    <>
                        <span
                            className="body2 footer-company-name font-change-footer"
                            style={spanStyle}
                        >
                            {' '}
                            &nbsp;|&nbsp;
                        </span>
                        <MuiLink
                            href={routePath.releaseNote}
                            target="_blank"
                            rel="noopener noreferrer"
                            {...commonAttributes}
                        >
                            Release Notes
                        </MuiLink>
                    </>
                ) : null}
            </Stack>
        </Stack>
    );
};

export default Footer;
